import React, {useState, useEffect, useCallback, useRef} from "react";
// import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// import { customerSlice } from "./../../store";
import { AuthService, CustomerService, EventsService, ResourceService } from "../../services";
import {
  YES_NO_TEXT,
} from "../../shared/constants/customer.constant";
import { RESOURCE_TYPE_OPTIONS, RESOURCE_TYPE_TEXT, formatResourceSpecialtyDisplay, formatProviderPhonesListDisplay } from "../../shared/constants/resource.constant";
import { pickRawSeatStorageForChart } from "../../shared/seatingTableDisplay";
import { useUnsavedChangesGuard, useFormDirtyTracker } from "../../shared";
import {
  readMedicalCreateEventPayload,
} from "../../shared/utils/medicalCreateEventPayload";
import {
  MedicalCustomerAsyncSelect,
  customerToMedicalSelectOption,
  loadMedicalAppointmentCustomerById,
} from "../../shared/components";
import { Button, Modal, Spinner, Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { ArrowCounterclockwise, Trash } from "react-bootstrap-icons";
import ReactPaginate from "react-paginate";

const PROVIDER_MODAL_PAGE_SIZE = 20;

const displayYesNoish = (value) => {
  if (value === "yes" || value === true) return "Yes";
  if (value === "no" || value === false) return "No";
  if (value === undefined || value === null || value === "") return "";
  const k = String(value).toLowerCase();
  return YES_NO_TEXT[k] || String(value);
};

const displayEyesOnForCustomer = (c) => {
  if (!c) return "";
  if (c.eyes_on != null && `${c.eyes_on}`.trim() !== "") return displayYesNoish(c.eyes_on);
  if (c.disability) return "Yes";
  return "";
};

const getResourceTypeDisplay = (r) => {
  if (!r) return "";
  const base = RESOURCE_TYPE_TEXT[r.type] || r.type || "";
  if (r.type === "other" && r.type_other) {
    return base ? `${base} (${r.type_other})` : r.type_other;
  }
  return base;
};

const getResourceNoteDisplay = (r) => {
  if (!r) return "";
  return r.note || r.description || "";
};

const getMedicalLabelValueSet = () =>
  new Set((EventsService.colorOptions || []).map((o) => o?.value).filter(Boolean));

/**
 * Medical label `<select>` only shows text when `value` matches an option.
 * Legacy rows may omit `color`, use "", or store a value no longer in the list — all read as blank.
 */
const normalizeMedicalLabelColorForExistingAppointment = (raw) => {
  const allowed = getMedicalLabelValueSet();
  const s = raw == null ? "" : `${raw}`.trim();
  if (!s) return "blue";
  if (s === "grey" && allowed.has("gray")) return "gray";
  if (allowed.has(s)) return s;
  return "blue";
};

const isMedicalEventInactiveOrArchived = (ev) => {
  if (!ev) return false;
  const s = `${ev.status ?? ""}`.trim().toLowerCase();
  return s === "inactive" || s === "archived";
};

/** Prefill provider on Create Medical Event when opened from a medical appointment request (or similar payload with a provider id). */
const resolveProviderFromMedicalCreatePayload = (event, resources = []) => {
  const resourceId = event?.data?.resource || event?.source_uuid;
  if (!resourceId) return { resource: undefined, selectValue: undefined };
  const resource = resources.find((item) => String(item.id) === String(resourceId));
  const label =
    resource?.name ||
    event?.data?.resource_name ||
    event?.source_name ||
    event?.data?.resource_display ||
    "";
  if (resource) {
    return {
      resource,
      selectValue: { value: resource.id, label: label || resource.name },
    };
  }
  if (!label) return { resource: undefined, selectValue: undefined };
  const stub = {
    id: resourceId,
    name: label,
    type: event?.data?.resource_type || event?.source_type,
    phone: event?.data?.resource_phone,
    contact: event?.data?.resource_contact,
    address: event?.data?.resource_address,
    city: event?.data?.resource_city,
    state: event?.data?.resource_state,
  };
  return { resource: stub, selectValue: { value: resourceId, label } };
};

function applyMedicalCustomerSelection(customer, setCustomerName, setCurrentCustomer) {
  if (!customer) {
    setCustomerName(undefined);
    setCurrentCustomer(undefined);
    return;
  }
  setCustomerName(customerToMedicalSelectOption(customer));
  setCurrentCustomer(customer);
}

const UpdateEvent = () => {
  const navigate = useNavigate();
  const urlParams = useParams();
  const [currentEvent, setCurrentEvent] =  useState(undefined);
  const [currentResource, setCurrentResource] = useState(undefined);
  const [resources, setResources] = useState([]);
  const [resourceType, setResourceType] = useState('');
  const [customerName, setCustomerName] = useState(undefined);
  const [currentCustomer, setCurrentCustomer] = useState(undefined);
  const [customerLoading, setCustomerLoading] = useState(false);
  const customerFetchRef = useRef(0);
  const [startTime, setStartTime] = useState('');
  const [title, setTitle] = useState('');
	const [description, setDescription] = useState('');
  const [newPatient, setNewPatient] = useState('');
  const [confirmed, setConfirmed] = useState('');
  const [fasting, setFasting] = useState('');
  const [interpreter, setInterpreter] = useState('');
  const [docOrder, setDocOrder] = useState('');
  const [disability, setDisability] = useState('');
  const [needId, setNeedId] = useState('');
  const [needMedicationList, setNeedMedicationList] = useState('');
  const [disabilitySupport, setDisabilitySupport] = useState('');
  const [notes, setNotes] = useState('');
  const [color, setColor] = useState('');
  const [reason, setReason] = useState('');
  const [otherRequirement, setOtherRequirement] = useState('');
  const [todayEvents, setTodayEvents] = useState([]);
  const [transportationInfo, setTransportationInfo] = useState(undefined);
  const [hideCreateFields, setHideCreateFields] = useState(false);
  const [timeData, setTimeData] = useState([]);
  const [transMethod, setTransMethod] = useState('');
  const [showResourceModal, setShowResourceModal] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [debouncedKeyword, setDebouncedKeyword] = useState('');
  const [providerModalPage, setProviderModalPage] = useState(0);
  const [providerModalItems, setProviderModalItems] = useState([]);
  const [providerModalTotal, setProviderModalTotal] = useState(0);
  const [providerModalLoading, setProviderModalLoading] = useState(false);
  const [providerModalError, setProviderModalError] = useState('');
  const [providerLoading, setProviderLoading] = useState(false);
  const providerFetchRef = useRef(0);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showRestoreConfirm, setShowRestoreConfirm] = useState(false);
  const [isDeletingEvent, setIsDeletingEvent] = useState(false);
  const [sameDayDuplicateModalOpen, setSameDayDuplicateModalOpen] = useState(false);
  const pendingCreateEventRef = useRef(null);
  const [isRestoringEvent, setIsRestoringEvent] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const hydratedEventKeyRef = useRef(null);

  const { isDirty, resetBaseline } = useFormDirtyTracker({
    customerId: customerName?.value ?? currentCustomer?.id ?? '',
    resourceId: currentResource?.id ?? '',
    startTime,
    title,
    description,
    newPatient,
    confirmed,
    fasting,
    interpreter,
    docOrder,
    disability,
    needId,
    needMedicationList,
    disabilitySupport,
    notes,
    color,
    reason,
    otherRequirement,
    transMethod,
  });
  const { tryNavigate, tryGoBack } = useUnsavedChangesGuard(isDirty);

  const isSite3 = window.location.hostname.includes('worldshine3.mayo.llc') || window.location.hostname.includes('site3');
  const params = new URLSearchParams(window.location.search);
  const isCreateMedicalEvent = Boolean(params.get('event') || params.get('eventKey'));
  const canDeleteMedicalEvent = Boolean(urlParams.id && !isCreateMedicalEvent);

  const backFallbackPath = () => {
    if (params.get('from') === 'calendar' || params.get('from') === 'create' || params.get('event') || params.get('eventKey')) {
      return `/medical/events/calendar`;
    }
    return '/medical/events/multiple-list';
  };

  const goBack = () => {
    tryGoBack(backFallbackPath());
  };

  const redirectAfterSave = () => {
    if (params.get('from') === 'calendar') {
      navigate(`/medical/events/calendar`);
    } else {
      if (params.get('from') === 'create') {
        navigate(`/medical/events/calendar`);
      } else {
        if (params.get('event') || params.get('eventKey')) {
          navigate(`/medical/events/calendar`);
        } else {
          navigate('/medical/events/multiple-list');
        }
      }
    }
  }

  const redirectToView = () => {
		tryNavigate(`/medical/events/${urlParams.id}`);
  }

  const validateEvent = (labelColor = color) => {
    const errors = [];
    if (customerLoading) {
      errors.push('Customer (still loading)');
    }
    if (!currentCustomer || !currentCustomer.id) {
      errors.push('Customer');
    }
    if (!startTime) {
      errors.push('Appointment Time');
    }
    if (providerLoading) {
      errors.push('Provider (still loading)');
    }
    if (!currentResource || !currentResource.id) {
      errors.push('Provider');
    }
    if (!newPatient) {
      errors.push('New Patient');
    }
    if (!docOrder) {
      errors.push('Order/Referral');
    }
    if (!fasting) {
      errors.push('Fasting Required');
    }
    if (!needId) {
      errors.push('ID Needed');
    }
    if (!needMedicationList) {
      errors.push('Need Medication List');
    }
    if (!interpreter) {
      errors.push('Language Support');
    }
    if (!reason || `${reason}`.trim() === '') {
      errors.push('Reason');
    }
    if (errors.length > 0) {
      window.alert(`Please fill in the following required fields:\n${errors.join('\n')}`);
      return false;
    }
    return true;
  };

  const persistEvent = async (newEvent) => {
    setIsSaving(true);
    try {
      if (isCreateMedicalEvent) {
        if (currentCustomer && currentResource) {
          await EventsService.createNewEvent(newEvent);
          resetBaseline();
          redirectAfterSave();
        }
      } else if (params.get('from') === 'create') {
        if (currentCustomer && currentResource) {
          await EventsService.updateEvent(urlParams.id, newEvent);
          resetBaseline();
          redirectAfterSave();
        }
      } else {
        await EventsService.updateEvent(urlParams.id, newEvent);
        resetBaseline();
        redirectAfterSave();
      }
    } catch (err) {
      console.error('Failed to save medical event', err);
      window.alert('Could not save this appointment. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  const saveEvent = async () => {
    if (isSaving) return;
    const updatingExistingAppointment = !params.get('event') && !params.get('eventKey');
    const resolvedLabelColor = updatingExistingAppointment
      ? normalizeMedicalLabelColorForExistingAppointment(color)
      : color;

    if (!validateEvent(resolvedLabelColor)) {
      return;
    }

    if (resolvedLabelColor !== color) {
      setColor(resolvedLabelColor);
    }

    let newEventDataClientAndResource = {};
    let newEventClientAndResource = {};
    if (currentCustomer) {
      newEventDataClientAndResource = Object.assign({}, newEventDataClientAndResource, {
        customer: currentCustomer.id,
        client_name: currentCustomer.name,
        client_pharmacy: currentCustomer.pharmacy,
        client_pcp: currentCustomer.care_provider,
        client_birth_date: currentCustomer.birth_date,
        client_seating: pickRawSeatStorageForChart(currentCustomer) || currentCustomer.seating
      });
      newEventClientAndResource = Object.assign({}, newEventClientAndResource, {
        target_type: currentCustomer.type,
        target_uuid: currentCustomer.id,
        target_name: currentCustomer.name
      })
    }
    if (currentResource) {
      newEventDataClientAndResource = Object.assign({}, newEventDataClientAndResource, {
        resource: currentResource.id,
        resource_type: currentResource.type,
        resource_name: currentResource.name,
        resource_phone: currentResource.phone,
        resource_contact: currentResource.contact,
        resource_address: currentResource.address,
        resource_city: currentResource.city,
        resource_state: currentResource.state,
      });
      newEventClientAndResource = Object.assign({}, newEventClientAndResource, {
        source_type: currentResource.type,
        source_uuid: currentResource.id,
        source_name: currentResource.name,
      })
    }
    
    const newEventData = {
      ...currentEvent.data,
      // legacy fields end
      // We still wanna keep the legacy fields below
      new_patient: newPatient,
      confirmed: confirmed,
      fasting: fasting,
      interpreter: interpreter,
      doc_order: docOrder,
      need_id: needId,
      need_med_list: needMedicationList,
      notes: notes,
      reason: reason,
      other: otherRequirement,
      disability: disability,
      disability_support: disabilitySupport,
      trans_method: transMethod,
      ...newEventDataClientAndResource
    }
    
    const newEvent = {
      ...currentEvent,
      data: newEventData,
      title: title,
      descrption: description,
      color: resolvedLabelColor,
      notes: notes,
      start_time: new Date(startTime),
      stop_time: new Date(startTime),
      edit_by: localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))?.name,
      edit_date: new Date(),
      edit_history: currentEvent?.edit_history? [...currentEvent.edit_history, { employee: localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))?.name, date: new Date() }] : [{ employee: localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))?.name, date: new Date() }],
      ...newEventClientAndResource
    }

    if (isCreateMedicalEvent && currentCustomer?.id && startTime) {
      setIsSaving(true);
      try {
        const hasSameDayAppointment = await EventsService.customerHasMedicalAppointmentOnDate(
          currentCustomer.id,
          startTime
        );
        if (hasSameDayAppointment) {
          pendingCreateEventRef.current = newEvent;
          setSameDayDuplicateModalOpen(true);
          return;
        }
      } catch (err) {
        console.error('Failed to check same-day medical appointments', err);
      } finally {
        setIsSaving(false);
      }
    }

    await persistEvent(newEvent);
  };

  /** Search ignores pagination so users can scan all matches at once. */
  const isProviderSearchActive = debouncedKeyword.trim().length > 0;
  const providerModalPageCount = isProviderSearchActive
    ? 0
    : Math.max(1, Math.ceil(providerModalTotal / PROVIDER_MODAL_PAGE_SIZE));

  const handleSelectProvider = useCallback((resourceSummary) => {
    if (!resourceSummary?.id) return;
    setShowResourceModal(false);

    const fetchId = ++providerFetchRef.current;
    setCurrentResource({ id: resourceSummary.id, name: resourceSummary.name || "" });
    setProviderLoading(true);

    ResourceService.getResource(resourceSummary.id)
      .then((response) => {
        if (providerFetchRef.current !== fetchId) return;
        setProviderLoading(false);
        if (response?.data) {
          setCurrentResource(response.data);
          return;
        }
        window.alert("Could not load provider details. Please try again.");
        setCurrentResource(undefined);
      })
      .catch(() => {
        if (providerFetchRef.current !== fetchId) return;
        setProviderLoading(false);
        window.alert("Could not load provider details. Please try again.");
        setCurrentResource(undefined);
      });
  }, []);

  useEffect(() => {
    if (!AuthService.canEditMedicalEvents()) {
      window.alert('You haven\'t login yet OR this user does not have access to this page. Please change an admin account to login.')
      AuthService.logout();
      navigate(`/login`);
      return;
    }
    if (params.get('from') === 'create') {
      setHideCreateFields(true);
    }

    if (isCreateMedicalEvent) {
      const pendingEvent = readMedicalCreateEventPayload(params);
      if (pendingEvent) {
        setCurrentEvent(pendingEvent);
      }

      const resourceId = pendingEvent?.data?.resource || pendingEvent?.source_uuid;
      if (resourceId) {
        ResourceService.getResource(resourceId)
          .then((response) => {
            if (response?.data) setCurrentResource(response.data);
          })
          .catch(() => {
            const { resource } = resolveProviderFromMedicalCreatePayload(pendingEvent, []);
            if (resource) setCurrentResource(resource);
          });
      }
      return;
    }

    Promise.all([
      ResourceService.getAll(),
      EventsService.getTimeData(),
    ]).then(([resourcesData, timeDatas]) => {
      setResources(resourcesData.data);
      setTimeData(timeDatas.data);
      EventsService.getEvent(urlParams.id).then((eventData) => {
        setCurrentEvent(eventData.data);
        EventsService.getAllEvents({ date: EventsService.formatDate(new Date(eventData.data.start_time)) }).then((eventsData) => {
          setTodayEvents(eventsData.data);
          const targetedEvent = eventsData.data.find((item) => item.id === urlParams.id);
          setTransportationInfo(
            EventsService.getTransportationInfo(eventsData.data, targetedEvent, timeDatas.data)
          );
        });
      });
    });
  }, []);


  /** Debounce the modal keyword so we don't hammer the server on every keystroke. */
  useEffect(() => {
    if (!showResourceModal) return undefined;
    const handle = setTimeout(() => setDebouncedKeyword(keyword), 250);
    return () => clearTimeout(handle);
  }, [keyword, showResourceModal]);

  /** Reset pagination + keyword whenever the modal opens so each launch is a fresh search. */
  useEffect(() => {
    if (showResourceModal) {
      setProviderModalPage(0);
    } else {
      setKeyword('');
      setDebouncedKeyword('');
      setProviderModalPage(0);
      setProviderModalItems([]);
      setProviderModalTotal(0);
      setProviderModalError('');
    }
  }, [showResourceModal]);

  /** Reset to first page whenever filters change so users don't land on an empty page. */
  useEffect(() => {
    setProviderModalPage(0);
  }, [debouncedKeyword, resourceType]);

  /** Fetch the visible page of providers from the API whenever filters or page change. */
  useEffect(() => {
    if (!showResourceModal) return undefined;

    const trimmedKeyword = debouncedKeyword.trim();
    const isSearching = trimmedKeyword.length > 0;

    const requestParams = {
      status: 'active',
      type: resourceType || undefined,
      keyword: isSearching ? trimmedKeyword : undefined,
      fields: 'summary',
    };
    if (!isSearching) {
      requestParams.page = providerModalPage + 1;
      requestParams.pageSize = PROVIDER_MODAL_PAGE_SIZE;
    }

    let cancelled = false;
    setProviderModalLoading(true);
    setProviderModalError('');

    ResourceService.listResources(requestParams)
      .then((response) => {
        if (cancelled) return;
        const payload = response?.data;
        if (Array.isArray(payload)) {
          /** Search mode (no page param): server returns a plain array of all matches. */
          setProviderModalItems(payload);
          setProviderModalTotal(payload.length);
        } else if (payload && Array.isArray(payload.items)) {
          /** Paginated mode: server returns `{ items, total, page, pageSize, totalPages }`. */
          setProviderModalItems(payload.items);
          setProviderModalTotal(Number(payload.total) || 0);
        } else {
          setProviderModalItems([]);
          setProviderModalTotal(0);
        }
      })
      .catch((err) => {
        if (cancelled) return;
        console.error('Failed to load providers', err);
        setProviderModalItems([]);
        setProviderModalTotal(0);
        setProviderModalError('Could not load providers. Please try again.');
      })
      .finally(() => {
        if (!cancelled) setProviderModalLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [showResourceModal, debouncedKeyword, resourceType, providerModalPage]);

  const onCustomerChange = useCallback((selectedCustomer) => {
    setCustomerName(selectedCustomer || undefined);

    if (!selectedCustomer?.value) {
      setCurrentCustomer(undefined);
      setCustomerLoading(false);
      return;
    }

    const fetchId = ++customerFetchRef.current;
    setCurrentCustomer(undefined);
    setCustomerLoading(true);

    loadMedicalAppointmentCustomerById(selectedCustomer.value).then((customer) => {
      if (customerFetchRef.current !== fetchId) return;
      setCustomerLoading(false);
      if (customer) {
        setCurrentCustomer(customer);
        return;
      }
      window.alert("Could not load customer details. Please try again.");
      setCustomerName(undefined);
    });
  }, []);

  useEffect(() => {
    if (!currentEvent) return;

    const hydrationKey =
      params.get("eventKey") ||
      (params.get("event") ? "legacy-event" : "") ||
      urlParams.id ||
      "";
    if (hydratedEventKeyRef.current === hydrationKey) return;

    const needsResourceList =
      !isCreateMedicalEvent &&
      Boolean(currentEvent.data?.resource || currentEvent.source_uuid);
    if (needsResourceList && resources.length === 0) return;

    let cancelled = false;

    const hydrateCustomer = async () => {
      if (currentEvent.data?.customer) {
        const customer = await loadMedicalAppointmentCustomerById(currentEvent.data.customer);
        if (cancelled) return customer;
        if (customer) {
          applyMedicalCustomerSelection(customer, setCustomerName, setCurrentCustomer);
          return customer;
        }
        setCustomerName({
          value: currentEvent.data.customer,
          label: currentEvent.data.client_name || currentEvent.target_name || "",
        });
        setCurrentCustomer(undefined);
        return null;
      }

      if (!currentEvent.target_uuid) return null;

      try {
        const clientRes = await CustomerService.getClient(currentEvent.target_uuid);
        const legacyClient = clientRes?.data;
        if (!legacyClient || cancelled) return null;

        const lookupKeyword = `${legacyClient.email || legacyClient.username || ""}`.trim();
        if (!lookupKeyword) return null;

        const searchRes = await CustomerService.listMedicalAppointmentCustomers({
          keyword: lookupKeyword,
          page: 1,
          pageSize: 10,
        });
        const items = Array.isArray(searchRes?.data)
          ? searchRes.data
          : searchRes?.data?.items || [];
        const mappingCustomer = items.find(
          (item) =>
            item.email === legacyClient.email && item.username === legacyClient.username
        );
        if (!cancelled && mappingCustomer) {
          applyMedicalCustomerSelection(mappingCustomer, setCustomerName, setCurrentCustomer);
          return mappingCustomer;
        }
      } catch (err) {
        console.error("Failed to resolve legacy client customer", err);
      }
      return null;
    };

    (async () => {
      const customer = await hydrateCustomer();
      if (cancelled) return;

      const isCreateFromMedicalRequest =
        isCreateMedicalEvent &&
        currentEvent?.type === "medical" &&
        Boolean(currentEvent?.data?.resource || currentEvent?.source_uuid);
      if (isCreateFromMedicalRequest) {
        if (!currentResource) {
          const { resource } = resolveProviderFromMedicalCreatePayload(currentEvent, resources);
          if (resource) setCurrentResource(resource);
        }
      } else if (!isCreateMedicalEvent) {
        const resourceId = currentEvent.data?.resource || currentEvent.source_uuid;
        const resource = resources.find((item) => String(item.id) === String(resourceId));
        setCurrentResource(resource);
      }

      setStartTime(new Date(currentEvent.start_time));
      setTitle(currentEvent.title);
      setColor(
        isCreateMedicalEvent
          ? currentEvent.color ?? ""
          : normalizeMedicalLabelColorForExistingAppointment(currentEvent.color)
      );
      setDescription(currentEvent.description);
      setNewPatient(currentEvent.data.new_patient);
      setConfirmed(currentEvent.data.confirmed);
      setFasting(currentEvent.data.fasting);
      setInterpreter(EventsService.normalizeLanguageSupportSelectValue(currentEvent.data.interpreter));
      setDocOrder(currentEvent.data.doc_order);
      setDisability(customer?.disability ? "yes" : currentEvent.data.disability);
      setDisabilitySupport(currentEvent.data.disability_support);
      setNeedId(currentEvent.data.need_id);
      setNeedMedicationList(currentEvent.data.need_med_list);
      setNotes(currentEvent.data.notes);
      setReason(currentEvent.data.reason);
      setOtherRequirement(currentEvent.data.other);
      setTransMethod(EventsService.normalizeTransportationSupportSelectValue(currentEvent?.data?.trans_method));

      hydratedEventKeyRef.current = hydrationKey;
      window.setTimeout(() => resetBaseline(), 100);
    })();

    return () => {
      cancelled = true;
    };
  }, [currentEvent, resources, isCreateMedicalEvent, urlParams.id]);

  const handleRemoveEventConfirmed = async () => {
    if (!urlParams.id || isDeletingEvent) return;
    const userName = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))?.name : '';
    setIsDeletingEvent(true);
    try {
      await EventsService.disableEvent(urlParams.id, {
        status: 'inactive',
        edit_by: userName,
        edit_date: new Date(),
        edit_history: currentEvent?.edit_history
          ? [...currentEvent.edit_history, { employee: userName, date: new Date() }]
          : [{ employee: userName, date: new Date() }],
      });
      setShowDeleteConfirm(false);
      resetBaseline();
      redirectAfterSave();
    } catch (err) {
      console.error(err);
      window.alert('Could not remove this appointment. Please try again.');
    } finally {
      setIsDeletingEvent(false);
    }
  };

  const handleRestoreEventConfirmed = async () => {
    if (!urlParams.id || isRestoringEvent) return;
    const userName = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))?.name : '';
    setIsRestoringEvent(true);
    try {
      await EventsService.updateEvent(urlParams.id, {
        status: 'active',
        edit_by: userName,
        edit_date: new Date(),
        edit_history: currentEvent?.edit_history
          ? [...currentEvent.edit_history, { employee: userName, date: new Date() }]
          : [{ employee: userName, date: new Date() }],
      });
      setShowRestoreConfirm(false);
      setCurrentEvent((prev) => (prev ? { ...prev, status: 'active' } : prev));
    } catch (err) {
      console.error(err);
      window.alert('Could not restore this appointment. Please try again.');
    } finally {
      setIsRestoringEvent(false);
    }
  };

  return (
    <>
      <div className="list row mb-4">
        <Breadcrumb>
          <Breadcrumb.Item href="/dashboard/dashboard">Medical</Breadcrumb.Item>
          <Breadcrumb.Item href={AuthService.getMedicalOneDayListPathOrFallback()}>
            Medical Appointment Information
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            { params.get('event') || params.get('eventKey') ? 'Create Medical Event' : 'Update Medical Event'}
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className="col-md-12 text-primary">
           <h4>{ isCreateMedicalEvent ? 'Create Medical Event' : 'Update Medical Event'} <button className="btn btn-link btn-sm" onClick={() => {goBack()}}>Back</button></h4> 
        </div>
      </div>

      <div className="app-main-content-list-container form-page">
				<div
					className={
						'app-main-content-list-func-container' +
						(canDeleteMedicalEvent ? ' medical-event-edit-page--has-delete' : '')
					}
				>
					{canDeleteMedicalEvent && (
						<div className="list-func-panel">
							{isMedicalEventInactiveOrArchived(currentEvent) ? (
								<Button
									type="button"
									variant="success"
									size="sm"
									onClick={() => setShowRestoreConfirm(true)}
								>
									<ArrowCounterclockwise size={16} className="me-2" aria-hidden />
									Restore event
								</Button>
							) : (
								<Button
									type="button"
									variant="danger"
									size="sm"
									onClick={() => setShowDeleteConfirm(true)}
								>
									<Trash size={16} className="me-2" aria-hidden />
									Remove event
								</Button>
							)}
						</div>
					)}
					<div id="event-tab">
						<div className="medical-event-edit-grid">
              {!hideCreateFields && (
                <>
              <div className="medical-event-edit-grid__cell">
                  <div className="column-card">
                    <h6 className="text-primary">Customer And Appointment Time</h6>
                    <div className="app-main-content-fields-section medical-event-edit-customer-time-row">
                      <div className="me-4 medical-event-edit-customer-time-row__customer">
                        <div className="field-label">Customer
                          <span className="required">*</span>
                        </div>
                        <div className="medical-event-edit-customer-select-mount">
                        <MedicalCustomerAsyncSelect
                          value={customerName || null}
                          onChange={onCustomerChange}
                        />
                        </div>
                      </div>
                      <div className="me-4 medical-event-edit-customer-time-row__appointment">
                        <div className="field-label">Appointment Time
                          <span className="required">*</span>
                        </div>
                        <DatePicker
                          selected={startTime}
                          onChange={setStartTime}
                          showTimeInput
                          timeInputLabel="Time:"
                          dateFormat="MM/dd/yyyy, HH:mm"
                        ></DatePicker>
                      </div>
                    </div>
                  </div>
              </div>
              <div className="medical-event-edit-grid__cell">
                  <div className="column-card">
                  {
                    customerLoading && (
                      <div className="text-center py-4">
                        <Spinner animation="border" size="sm" role="status" />
                        <div className="text-muted small mt-2">Loading customer information…</div>
                      </div>
                    )
                  }
                  {
                    currentCustomer && !customerLoading && <>
                      <h6 className="text-primary">Customer Information</h6>
                        <div className="app-main-content-fields-section short">
                          <div className="field-body">
                            <div className="field-label">Customer Name</div> 
                            <div className="field-value">{currentCustomer?.name || ''}</div>
                          </div>
                          <div className="field-body">
                            <div className="field-label">Preferred Name</div> 
                            <div className="field-value">{currentCustomer?.name_cn || ''}</div>
                          </div>
                          <div className="field-body">
                            <div className="field-label">Pharmacy</div> 
                            <div className="field-value">{currentCustomer?.pharmacy || ''}</div>
                          </div>
                        </div>
                        <div className="app-main-content-fields-section short">
                          <div className="field-body">
                            <div className="field-label">Care Provider</div> 
                            <div className="field-value">{currentCustomer?.care_provider || ''}</div>
                          </div>
                          <div className="field-body">
                            <div className="field-label">Birthday</div> 
                            <div className="field-value">{currentCustomer?.birth_date || ''}</div>
                          </div>
                          <div className="field-body">
                            <div className="field-label">Note</div> 
                            <div className="field-value">{currentCustomer?.note || ''}</div>
                          </div>
                        </div>
                        <div className="app-main-content-fields-section short">
                          <div className="field-body">
                            <div className="field-label">Eyes-On</div>
                            <div className="field-value">{displayEyesOnForCustomer(currentCustomer)}</div>
                          </div>
                          <div className="field-body">
                            <div className="field-label">Has Airtag</div>
                            <div className="field-value">{displayYesNoish(currentCustomer?.has_airtag)}</div>
                          </div>
                          <div className="field-body">
                            <div className="field-label">Lift-Equipped Vehicle Required</div>
                            <div className="field-value">{displayYesNoish(currentCustomer?.wheelchair)}</div>
                          </div>
                        </div>
                    </>
                  }
                  </div>
              </div>
              </>
              )}
              <div className="medical-event-edit-grid__cell">
                  <div className="column-card">
                  <h6 className="text-primary">Appointment Details</h6>
                  <div className="app-main-content-fields-section">
                    <div className="me-4">
                      <div className="field-label">Provider
                        <span className="required">*</span>
                      </div>
                      {currentResource ? 
                      (<><span>{currentResource?.name}</span> <span><button className="btn btn-link btn-sm me-2 mb-2" onClick={()=> setShowResourceModal(true)}>Update</button></span></>)  : 
                      ((!isCreateMedicalEvent && currentEvent?.data?.resource_name) ? <><span>{currentEvent?.data?.resource_name}</span> <span><button className="btn btn-link btn-sm me-2 mb-2" onClick={()=> setShowResourceModal(true)}>Update</button></span></> : <button className="btn btn-link btn-sm me-2 mb-2" onClick={()=> setShowResourceModal(true)}>Please click here to add provider</button>)}
                    </div>
                  </div>
                  <div className="app-main-content-fields-section medical-event-appointment-details-subfields">
                    <div className="me-4">
                      <div className="field-label">New Patient
                        <span className="required">*</span>
                      </div>
                      <select value={newPatient} onChange={e => setNewPatient(e.target.value)}>
                        <option value=""></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div className="me-4">
                      <div className="field-label">Order/Referral
                        <span className="required">*</span>
                      </div>
                      <select value={docOrder} onChange={e => setDocOrder(e.target.value)}>
                        <option value=""></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div className="me-4">
                      <div className="field-label">Fasting Required
                        <span className="required">*</span>
                      </div>
                      <select value={fasting} onChange={e => setFasting(e.target.value)}>
                        <option value=""></option>
                        <option value="empty_stomach">Empty Stomach</option>
                        <option value="clear_liquid">Clear Liquid</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="app-main-content-fields-section">
                    <div className="me-4">
                      <div className="field-label">ID Needed
                        <span className="required">*</span>
                      </div>
                      <select value={needId} onChange={e => setNeedId(e.target.value)}>
                        <option value=""></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div className="me-4">
                      <div className="field-label">Need Medication List
                        <span className="required">*</span>
                      </div>
                      <select value={needMedicationList} onChange={e => setNeedMedicationList(e.target.value)}>
                        <option value=""></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <h6 className="text-primary">Assistance</h6>
                  <div className="app-main-content-fields-section">
                    <div className="me-4">
                      <div className="field-label">Language Support
                        <span className="required">*</span>
                      </div>
                      <select value={EventsService.normalizeLanguageSupportSelectValue(interpreter)} onChange={e => setInterpreter(e.target.value)}>
                        <option value=""></option>
                        {
                          EventsService.interpreterLevelOptions?.map((item) => (
                            <option key={item?.value} value={item?.value}>{item?.label}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className="me-4">
                      <div className="field-label">Transportation Support
                      </div>
                      <select
                        value={EventsService.normalizeTransportationSupportSelectValue(transMethod)}
                        onChange={e => setTransMethod(e.target.value)}
                      >
                        {
                          EventsService.transportationTypeOptions?.map((item) => <option key={item?.value} value={item?.value}>{item?.label}</option>)
                        }
                      </select>
                    </div>
                  </div>
                  <h6 className="text-primary">Additional Information</h6>
                  <div className="app-main-content-fields-section medical-event-additional-textareas">
                    <div>
                      <div className="field-label">Notes
                      </div>
                      <textarea className="medical-event-additional-textarea" value={notes || ''} onChange={e => setNotes(e.target.value)}/>
                    </div>
                    <div>
                      <div className="field-label">Reason
                        <span className="required">*</span>
                      </div>
                      <textarea className="medical-event-additional-textarea" value={reason || ''} onChange={e => setReason(e.target.value)}/>
                    </div>
                    <div>
                      <div className="field-label">Requirement
                      </div>
                      <textarea className="medical-event-additional-textarea" value={otherRequirement || ''} onChange={e => setOtherRequirement(e.target.value)}/>
                    </div>
                  </div>
                  
                  </div>
              </div>
              <div className="medical-event-edit-grid__cell">
                  {(providerLoading || currentResource) && <div className="column-card">
                    {providerLoading && (
                      <div className="text-center py-4">
                        <Spinner animation="border" size="sm" role="status" />
                        <div className="text-muted small mt-2">Loading provider information…</div>
                      </div>
                    )}
                    {currentResource && !providerLoading && <>
                    <h6 className="text-primary">Provider Info</h6>
                    <div className="app-main-content-fields-section short">
                      <div className="field-body">
                        <div className="field-label">Name</div>
                        <div className="field-value">{currentResource?.name || currentEvent?.data?.resource_name || ''}</div>
                      </div>
                      <div className="field-body">
                        <div className="field-label">Specialty</div>
                        <div className="field-value">{formatResourceSpecialtyDisplay(currentResource)}</div>
                      </div>
                      
                    </div>
                    <div className="app-main-content-fields-section short">
                      <div className="field-body">
                        <div className="field-label">Primary Phone Number</div>
                        <div className="field-value">{currentResource?.phone || currentEvent?.data?.resource_phone || ""}</div>
                      </div>
                      <div className="field-body">
                        <div className="field-label">Phone Number 2</div>
                        <div className="field-value">{currentResource?.contact || currentEvent?.data?.resource_contact || ""}</div>
                      </div>
                      <div className="field-body">
                        <div className="field-label">Fax Number</div>
                        <div className="field-value">{currentResource?.fax || currentEvent?.data?.resource_fax || ""}</div>
                      </div>
                    </div>
                    <div className="app-main-content-fields-section short">
                      <div className="field-body">
                        <div className="field-label">Address</div>
                        <div className="field-value">{currentResource?.address || currentEvent?.data?.resource_address || ""}</div>
                      </div>
                    </div>
                    <div className="app-main-content-fields-section short">
                      <div className="field-body">
                        <div className="field-label">Type</div>
                        <div className="field-value">{getResourceTypeDisplay(currentResource)}</div>
                      </div>
                      <div className="field-body">
                        <div className="field-label">Note</div>
                        <div className="field-value" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                          {getResourceNoteDisplay(currentResource)}
                        </div>
                      </div>
                    </div>
                    </>}
                  </div>}
              </div>
            </div>
            <div className="list row mb-4">
              <div className="col-md-12 col-sm-12 col-xs-12">
                <button className="btn btn-default btn-sm float-right" onClick={() => goBack()} disabled={isSaving}> Cancel </button>
                <button className="btn btn-primary btn-sm float-right" onClick={() => saveEvent()} disabled={isSaving}>
                  {isSaving ? "Saving…" : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showResourceModal} fullscreen={true} onHide={() => setShowResourceModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Select the Provider</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="app-main-content-fields-section">
            <div className="mb-4 me-4">
              <div className="field-label">Type in Keyword to Filter</div>
              <input type="text" value={keyword} onChange={e => setKeyword(e.target.value)}/>
            </div>
            <div className="mb-4 me-4">
              <div className="field-label">Filter By Provider Type</div>
              <select value={resourceType} onChange={e => setResourceType(e.target.value)}>
                <option value=""></option>
                {RESOURCE_TYPE_OPTIONS.map((item) => (
                  <option key={item.value} value={item.value}>{item.label}</option>
                ))}
              </select>
            </div>
          </div>
          <table className="personnel-info-table mb-4"> 
            <thead>
              <tr className="sortable-header">
                <th>Name</th>
                <th>Specialty</th>
                <th>Address</th>
                <th>Office Name</th>
                <th>Phone Number</th>
                <th>Provider Note</th>
                <th></th>
              </tr>
              
            </thead>
            <tbody>
              {providerModalItems.map(resource => <tr key={resource.id}>
                  <td>{resource?.name || ''}</td>
                  <td>{formatResourceSpecialtyDisplay(resource)}</td>
                  <td>{resource?.address}</td>
                  <td>{resource?.office_name || resource?.name_original || ''}</td>
                  <td style={{ whiteSpace: 'pre-line' }}>{formatProviderPhonesListDisplay(resource) || '-'}</td>
                  <td style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{resource?.note || resource?.description || ''}</td>
                  <td style={{'minWidth': '220px'}}>{ resource?.id === currentResource?.id ? 'Selected' : (<Button variant="primary" className="me-2" size="sm" onClick={() => handleSelectProvider(resource)}>Select</Button>)}</td>
                </tr>)}
              {!providerModalLoading && providerModalItems.length === 0 && (
                <tr>
                  <td colSpan={7} className="text-center text-muted">
                    {providerModalError || 'No providers match the current filters.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {providerModalLoading && (
            <div className="text-center mb-3">
              <Spinner animation="border" size="sm" /> <span className="ms-2">Loading providers...</span>
            </div>
          )}
          {!isProviderSearchActive && providerModalTotal > PROVIDER_MODAL_PAGE_SIZE && (
            <div className="pagination-container">
              <ReactPaginate
                key={`provider-modal-${resourceType}`}
                className="customers-pagination"
                breakLabel="..."
                nextLabel="Next"
                onPageChange={(event) => setProviderModalPage(event.selected)}
                pageRangeDisplayed={5}
                pageCount={providerModalPageCount}
                forcePage={providerModalPage}
                previousLabel="Prev"
                renderOnZeroPageCount={null}
                containerClassName="pagination justify-content-center"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-prev-item"
                previousLinkClassName="page-link"
                nextClassName="page-next-item"
                nextLinkClassName="page-link"
                activeClassName="active"
                breakClassName="page-item"
                breakLinkClassName="page-link"
              />
              <div className="select-page-container">
                <div className="per-page-label">{`Page ${providerModalPage + 1} of ${providerModalPageCount} (${providerModalTotal} total)`}</div>
              </div>
            </div>
          )}
          {isProviderSearchActive && !providerModalLoading && providerModalItems.length > 0 && (
            <div className="text-center text-muted mb-3">
              {`Showing ${providerModalItems.length} result${providerModalItems.length === 1 ? '' : 's'} for "${debouncedKeyword.trim()}"`}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowResourceModal(false)}>
            Complete And Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteConfirm}
        onHide={() => !isDeletingEvent && setShowDeleteConfirm(false)}
        centered
        backdrop={isDeletingEvent ? 'static' : true}
        keyboard={!isDeletingEvent}
      >
        <Modal.Header closeButton={!isDeletingEvent}>
          <Modal.Title>Remove medical appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            Are you sure you want to remove this appointment
            {currentCustomer?.name ? (
              <> for <strong>{currentCustomer.name}</strong></>
            ) : null}
            ? It will be marked inactive and hidden from active lists; you can still find it using inactive filters where available.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteConfirm(false)} disabled={isDeletingEvent}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleRemoveEventConfirmed} disabled={isDeletingEvent}>
            {isDeletingEvent ? 'Removing…' : 'Remove'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRestoreConfirm}
        onHide={() => !isRestoringEvent && setShowRestoreConfirm(false)}
        centered
        backdrop={isRestoringEvent ? 'static' : true}
        keyboard={!isRestoringEvent}
      >
        <Modal.Header closeButton={!isRestoringEvent}>
          <Modal.Title>Restore medical appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            Restore this appointment
            {currentCustomer?.name ? (
              <> for <strong>{currentCustomer.name}</strong></>
            ) : null}
            ? It will be marked active again and appear on calendars and active lists.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRestoreConfirm(false)} disabled={isRestoringEvent}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleRestoreEventConfirmed} disabled={isRestoringEvent}>
            {isRestoringEvent ? 'Restoring…' : 'Restore'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={sameDayDuplicateModalOpen}
        onHide={() => {
          if (isSaving) return;
          pendingCreateEventRef.current = null;
          setSameDayDuplicateModalOpen(false);
        }}
        centered
      >
        <Modal.Header closeButton={!isSaving}>
          <Modal.Title>Existing appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          A medical appointment already exists for this customer on the same day. Do you wish to continue?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={isSaving}
            onClick={() => {
              pendingCreateEventRef.current = null;
              setSameDayDuplicateModalOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={isSaving}
            onClick={async () => {
              const pendingEvent = pendingCreateEventRef.current;
              pendingCreateEventRef.current = null;
              setSameDayDuplicateModalOpen(false);
              if (pendingEvent) {
                await persistEvent(pendingEvent);
              }
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateEvent;